enum StripePricingIds {
  BOOTCAMP = 'bootcamp',
  AllACCESS_MONTHLY = 'allaccess-monthly',
  AllACCESS_ANNUAL = 'allaccess-yearly',
  AllACCESS_QUARTERLY = 'allaccess-3-month',
}

export default StripePricingIds;